import { useFormContext } from "react-hook-form";
import { YesNoFieldProps } from "./YesNo.types";
import { FormControl, FormDescription, FormField, FormItem, FormMessage } from "@shadcn/components/ui/form";
import { getValidationConfig } from "@forms/form-render/helpers/getValidationConfig";
import { getFieldHelperText } from "@forms/form-render/helpers/getFieldHelperText";
import RadioCards from "@shadcn/components/ui/radio-group-cards";
import { Label } from "@shadcn/components/ui/label";
import { OptionSchema } from "@schema-types/types/JourneySchema";

function toYesNoBoolean(value: unknown): boolean | undefined {
  if (value === true) return true;
  if (value === false) return false;
  if (value === "true") return true;
  if (value === "false") return false;
  return undefined;
}

export const YesNo = ({ config, required, validation, label, name, disabled }: YesNoFieldProps) => {
  const { control } = useFormContext();
  const description = getFieldHelperText(config.helperText, required);
  const validationConfig = getValidationConfig(validation);

  const options: OptionSchema[] = [
    { label: "Yes", value: "true", isDefault: config.defaultValue === "yes" },
    { label: "No", value: "false", isDefault: config.defaultValue === "no" }
  ];

  const defaultValue =
    config.defaultValue === "yes" ? true : config.defaultValue === "no" ? false : undefined;

  return (
    <FormField
      control={control}
      name={name}
      rules={{
        ...validationConfig,
        validate: (value) => {
          if (!required) return true;
          const v = toYesNoBoolean(value);
          if (v !== true && v !== false) return "This is a required field";
          return true;
        },
      }}
      defaultValue={defaultValue}
      render={({ field }) => {
        const selected = toYesNoBoolean(field.value);
        return (
          <FormItem className="space-y-2">
            {label && <Label htmlFor={name}>{label}</Label>}
            <FormMessage />
            <FormControl>
              <RadioCards
                options={options}
                defaultValue={defaultValue === true ? "true" : defaultValue === false ? "false" : undefined}
                value={selected === true ? "true" : selected === false ? "false" : undefined}
                disabled={disabled}
                onValueChange={(value) => field.onChange(value === "true")}
              />
            </FormControl>
            {description && <FormDescription>{description}</FormDescription>}
          </FormItem>
        );
      }}
    />
  );
};
